var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBack = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86836 6.75156L6.54336 10.4266C6.69336 10.5766 6.76523 10.7516 6.75898 10.9516C6.75273 11.1516 6.67461 11.3266 6.52461 11.4766C6.37461 11.6141 6.19961 11.6859 5.99961 11.6922C5.79961 11.6984 5.62461 11.6266 5.47461 11.4766L0.524609 6.52656C0.449609 6.45156 0.396484 6.37031 0.365234 6.28281C0.333984 6.19531 0.318359 6.10156 0.318359 6.00156C0.318359 5.90156 0.333984 5.80781 0.365234 5.72031C0.396484 5.63281 0.449609 5.55156 0.524609 5.47656L5.47461 0.526562C5.61211 0.389062 5.78398 0.320312 5.99023 0.320312C6.19648 0.320312 6.37461 0.389062 6.52461 0.526562C6.67461 0.676562 6.74961 0.854687 6.74961 1.06094C6.74961 1.26719 6.67461 1.44531 6.52461 1.59531L2.86836 5.25156H11.2496C11.4621 5.25156 11.6402 5.32344 11.784 5.46719C11.9277 5.61094 11.9996 5.78906 11.9996 6.00156C11.9996 6.21406 11.9277 6.39219 11.784 6.53594C11.6402 6.67969 11.4621 6.75156 11.2496 6.75156H2.86836Z",
    fill: "#C8131B"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/back.f80465d0.svg";
export { ForwardRef as ReactComponent };